import { from } from '../observable/from';
import { Observable } from '../Observable';
import { createOperatorSubscriber } from './OperatorSubscriber';
export function switchMap(project) {
    return function (source) {
        return new Observable(function (subscriber) {
            var innerSubscriber = null;
            var index = 0;
            var isComplete = false;
            var checkComplete = function () { return isComplete && !innerSubscriber && subscriber.complete(); };
            source.subscribe(createOperatorSubscriber(subscriber, function (value) {
                innerSubscriber === null || innerSubscriber === void 0 ? void 0 : innerSubscriber.unsubscribe();
                var outerIndex = index++;
                from(project(value, outerIndex)).subscribe((innerSubscriber = createOperatorSubscriber(subscriber, undefined, function () {
                    innerSubscriber = null;
                    checkComplete();
                })));
            }, function () {
                isComplete = true;
                checkComplete();
            }));
        });
    };
}
//# sourceMappingURL=switchMap.js.map